/** Display an arcade completion time without converting it into points. */
export function formatTime(durationMs) {
    if (!Number.isFinite(durationMs) || durationMs < 0) return '—';
    const ms = Math.floor(durationMs);
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor(ms / 1000) % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}.${String(ms % 1000).padStart(3, '0')}`;
}
